import { render } from "./HeaderVue.vue?vue&type=template&id=6e1da36f"
import script from "./HeaderVue.vue?vue&type=script&lang=js"
export * from "./HeaderVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__